/* eslint-disable react-hooks/exhaustive-deps */
/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { ChunkedEditorShell } from 'components/VideoPlayer/Transcription/MediaPlayer/Transcript/ChunkedEditorShell';
import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'reducers';

type Props = {
  /** Binds chunk store to media + transcript revision (latest or history version). */
  documentKey?: string | null;
};

export const CaptionEditor = React.memo(({ documentKey }: Props) => {
  // Playback highlight is DOM/rAF — do not push timeupdate into React state.
  const [currentTime] = useState(0);

  const caption = useSelector((state: RootState) => state.player.caption);
  const { id: mediaid } = useParams<{ id: string }>();
  const boundDocumentKey = documentKey
    ? `${documentKey}:caption`
    : `${mediaid ?? 'media'}:caption`;

  return (
    <ErrorBoundary
      fallback={
        <div tw="font-medium text-sonnant-grey-6 text-16 mt-5">
          Cannot load content item's transcripts
        </div>
      }
      onError={(e) => console.log('Caption Error:', e)}
    >
      <ChunkedEditorShell
        fullDocument={caption}
        videoTimePosition={currentTime}
        documentKey={boundDocumentKey}
      />
    </ErrorBoundary>
  );
});
